import { VoieDeRecours } from './sections/voies-de-recours.jsx'
import { RetourInfoContact } from './sections/retour-info-contact.jsx'
import { Plan } from './sections/plan.jsx'

export const NotOrangeOrSosh = (props) => {
  return (
    <div class="site-width">
      <div class="header-wrapper mb-2 mb-md-3">
        <div class="container-fluid">
          <h1 class="pb-0 mt-1 mt-md-2 mb-1 mb-md-2">Déclaration d'accessibilité</h1>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-10 col-xl-8">
            <div class="alert-container alert-info mb-2" role="alert">
              <p class="alert">
                <span class="alert-icon icon-info" aria-hidden="true"></span>
                <span class="text-mw">
                  Il y a une erreur dans votre requête, la page n'appartient pas au domaine Orange France ou Sosh, nous ne pouvons pas afficher de déclaration.
                </span>
              </p>
            </div>

            <Plan />

            <RetourInfoContact />

            <VoieDeRecours />
          </div>
        </div>
      </div>
    </div>
  )
}
